
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code3 } from "./data";

export default defineComponent({
  name: "buttons-with-background-color",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code3
    };
  }
});
